// The city the map opens on. Kyiv only for now (PROJECT); the header city selector replaces this.
export interface MapCity {
	slug: string;
	timezone: string;
	center: { lat: number; lng: number };
	zoom: number;
}

export const DEFAULT_CITY: MapCity = {
	slug: 'kyiv',
	timezone: 'Europe/Kyiv',
	center: { lat: 50.4501, lng: 30.5234 },
	zoom: 12,
};
